import * as React from 'react';
import { connect } from 'react-redux';
import {
  Title,
  RouteWrapper,
  UserCreateForm,
  UserList,
} from '../../components';
import { getUsers } from '../../redux/actions/users';

interface Props {
  users: any;
  dispatch: Function;
}

class Route extends React.Component<Props> {
  componentDidMount() {
    this.props.dispatch(getUsers());
  }

  render() {
    return (
      <RouteWrapper
        title="Users"
        requireAuth
        requirePermission="MANAGE_USERS"
        breadcrumbs={[
          { link: '/settings', text: 'Settings' },
          { link: '/settings/users', text: 'Users' },
        ]}
      >
        <div className="container">
          <div className="columns">
            <div className="column">
              <Title>Users</Title>
              {!this.props.users.isFetching && (
                <UserList
                  items={this.props.users.users}
                  showEmail
                  showJoinDate
                />
              )}
            </div>
            <div className="column is-5">
              <UserCreateForm />
            </div>
          </div>
        </div>
      </RouteWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
});

export default connect(mapStateToProps)(Route);
